import { render, staticRenderFns } from "./CharacterModule.vue?vue&type=template&id=60c1ad51&"
import script from "./CharacterModule.vue?vue&type=script&lang=js&"
export * from "./CharacterModule.vue?vue&type=script&lang=js&"
import style0 from "./CharacterModule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports